module.exports = __webpack_public_path__ + "static/media/logo.ecb897fd.png";